module.exports = __webpack_public_path__ + "img/1440.5619ca10.jpg";